import { sendRequestWithAuth } from 'transport/sendRequestWithAuth'

import {
  RegistrationData,
  RegistrationLkmData,
  TRegistrationBody,
  TRegistrationLkmBody,
} from './types'

// регистрация
export async function sendRegistrationData(data: RegistrationData) {
  if (!data.address) throw new Error('address problems!')

  const requestBody: TRegistrationBody = {
    firstName: data.firstname,
    lastName: data.lastname,
    fatherName: data.middlename,
    customerAddress: data.address,
    agreeProcessingPersonalData: data.personalAgree,
    agreeSubscribeAdvertising: data?.advAgree || false,
  }

  const response = await sendRequestWithAuth.post(
    '/v1/customer/registration',
    requestBody,
  )
  return response.data
}

export async function sendRegistrationDataLkm(data: RegistrationLkmData) {
  if (!data.address) throw new Error('address problems!')
  const requestBody: TRegistrationLkmBody = {
    firstName: data.firstname,
    lastName: data.lastname,
    fatherName: data.middlename,
    email: data.email,
    companyName: data.companyName,
    locationAddress: data.address.address,
    agreeProcessingPersonalData: data.personalAgree,
    productTypes: data.productTypes,
    serviceRegions: data.serviceRegions.map(
      ({ kladrId, regionKladrId, cityKladrId, areaKladrId }) => ({
        kladrId,
        regionKladrId,
        cityKladrId,
        areaKladrId,
      }),
    ),
  }

  const response = await sendRequestWithAuth.post(
    '/v1/fitter/registration',
    requestBody,
  )
  return response.data
}
